import React from 'react';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import PropTypes from 'prop-types';

export default function ErrorMessage(props) {
	const {id, className, message, icons} = props;
	return (
		<MotifErrorMessage id={id} className={className} icons={icons}>
			{message}
		</MotifErrorMessage>
	);
}

ErrorMessage.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	message: PropTypes.string,
	icons: PropTypes.node
};
